module.exports = __webpack_public_path__ + "img/lightMode.645cc28a.svg";